import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const zh = {
    "indextitle": {
        "LDDBid": "LDDB id",
        "ProteinId": "靶点蛋白",
        "ProteinDescription": "蛋白描述",
        "GeneNames": "基因名称",
        "ProbeId": "探针编号",
        "Density": "Probe浓度",
        "ProbeStructImg": "探针结构图",
        "ProbeType": "探针类型",
        "": "标记位点详情",
        "LigandId": "竞争分子",
        "concentration": "浓度",
        "CompetitiveRatio": "竞争比值（P/PC）",
        "CellLine": "细胞系",
        "Source": "数据来源",
        "Species": "物种",
        "EntryName": "Uniprot 蛋白名称",
        "UniparcID": "Uniparc 编号",
        "TddId": "TDD 编号",
        "TargType": "TTD 靶点类型",
        "Synonyms": "別名",
        "Function": "TTD 功能",
        "BioClass": "TTD 生物学分类",
        "TTDDrugID": "TTD 药物编号",
        "TTDDrugName": "TTD 药物名称",
        "TTDDrugGroup": "TTD 药物阶段",
        "WikiPath": "WIKIPATH",
        "NetPath": "NET_PATH",
        "IntePath": "INTEPATH",
        "PantPath": "PANTPATH",
        "GoBp": "生物学过程",
        "GoCc": "细胞组成",
        "GoMf": "分子功能",
        "Disease": "疾病",
        "CellularLocation": "亚细胞定位",
        "InteractsWith": "互相蛋白",
        "ProteinFamilies": "蛋白质家族",
        "KeggPathway": "KEGG 通路",
        "TargetHierarchy": "靶点层次结构",
        "KeggDrug": "KEGG 药物",
        "DrugBankID": "DrugBank 药物编号",
        "DrugBankName": "DrugBank 药物名称",
        "DrugBankGroups": "DrugBank 药物阶段/类别",
        "DrugCrntralID": "DrugCentral 靶点编号",
        "DrugCrntralName": "DrugCentral 药物名称",
        "ChEMBL": "ChEMBL",
        "GuidetoPHARMACOLOGY": "GuidetoPHARMACOLOGY",
        "BindingDB": "BindingDB",
        "IntramembraneInterval": "Intramembrane 区间",
        "IntramembraneDescription": "Intramembrane 描述",
        "IntramembraneEvidence": "Intramembrane 引用",
        "TransmembraneInterval": "Transmembrane 区间",
        "TransmembraneDescription": "Transmembrane 描述",
        "TransmembraneEvidence": "Transmembrane 引用",
        "DomainCCDescription": "Domain [CC] 描述",
        "DomainCCEvidence": "Domain [CC] 引用",
        "DomainFTInterval": "Domain [FT] 区段",
        "DomainFTDescription": "Domain [FT] 描述",
        "DomainFTEvidence": "Domain [FT] 引用"
    },
    "indexbutton": {
        "selectall": "全选",
        "off": "关闭",
        "save": "保存",
        "inputfor": "请输入搜索内容...",
        "append": "添加",
        "search": "搜索",
        "delete": "删除",
        "selectoption": {
            "ALL": "ALL",
            "LDDBid": "LDDB id",
            "ProteinId": "靶点蛋白",
            "Species": "物种",
            "ProteinDescription": "蛋白描述",
            "GeneNames": "基因名",
            "ProbeId": "探针 ID",
            "ProbeType": "探针类型",
            "SitesList": "标记位点",
            "Density": "浓度",
            "CompetitiveRatio": "竞争比值（P/PC）",
            "LigandId": "竞争分子",
            "Source": "数据来源"
        }
    },
    "indexwarn": {
        "downwarn": "请选择要下载的数据",
        "downwarntitle": "提醒"
    },
    "button": {
        "advanced_search": "高级搜索",
        "structure_search": "结构式搜索",
        "structure_pic_search": "结构式图片搜索",
        "change_password": "修改密码",
        "quit": "退出",
        "Downloadselection": "下载选择",
        "Downloadselecteddata": "下载选中数据",
        "Downloadalldata": "下载全部数据",
        "Download": "立即下载"
    },
    "tztitle": {
        "concentration": "浓度",
        "competitiveratio": "竞争比值 (P/PC)",
        "competing_ligand": "竞争分子",
        "cell_line": "细胞系",
        "experimental_data_source": "实验数据来源"
    },
    "des": {
        "title": "靶点蛋白ID 和 物种 和分类",
        "entry": "靶点ID",
        "entry_name": "蛋白名称",
        "protein_names": "蛋白描述",
        "protein_families": "蛋白质家族",
        "target_hierarchy": "靶点层次结构",
        "gene_names": "基因名称",
        "taxonomy": "分类",
        "goclass": "GO 类别",
        "goDescription": "GO 通路",
        "gono": "GO 编号",
        "cellularlocation": "细胞内定位",
        "KEGGNo": "KEGG 编号",
        "KEGGterm": "KEGG 通路",
        "ActIveSite": "位点",
        "ActIveType": "类型",
        "ActIvePosition": "位置",
        "ActIveDescription": "描述",
        "3DStructure": "三维结构",
        "ProbeID": "探针ID",
        "Structure": "结构",
        "WarheadType": "类型",
        "Labelingsites": "位点",
        "SOURCE": "来源",
        "ProbeligangList": "探针和连接列表",
        "AnnotationLocation": "注释和位置",
        "logP": "logP",
        "logS": "logS",
        "Heavy Atom Count": "重原子数",
        "Ring Count": "环数",
        "Hydrogen Bond Acceptor Count": "氢键受体数",
        "Hydrogen Bond Donor Count": "氢键供体数",
        "Rotatable Bond Count": "可旋转键数",
        "Topological Polar Surface Area": "拓扑极表面积",
        "solvent accessible surface area": "溶剂可及表面积",
        "DiseaseDrug": "疾病和药物",
        "Disease": "疾病",
        "MIMNo": "MIM 编号",
        "Description": "描述",
        "Evidence": "引用",
        "Note": "注释",
        "score": "打分",
        "cancelscore": "取消打分",
        "targetscreeningmethod": "靶点筛选方法",
        "methoddescription": "方法描述",
    },
    "probe": {
        "ProbeID": "探针编号",
        "TargetProteins": "靶点蛋白",
        "species": "物种",
        "ProteinDescription": "蛋白描述",
        "GeneName": "基因名称",
        "LabeledSitesDetail": "标记位点",
        "Concentration": "浓度",
        "ratio": "竞争比值(P/PC)",
        "competitiveligand": "竞争配体",
        "cellline": "细胞系",
        "datasource": "实验数据来源"
    },
    "site": {
        "Targetname": "靶点蛋白名",
        "Probename": "探针名称",
        "Siteslist": "位点列表",
        "Sitesvisualization": "位点展示",
        "datasource": "实验数据来源"
    },
    ...zhLocale
}

export default zh


// WEBPACK FOOTER //
// ./src/common/i18n/zh.js